import { useParams } from 'react-router-dom'

import { useScansOfCurrentStore } from '@state/scans'

export const LATEST_SCAN_KEYWORD = 'latest'

export function useScan() {
  const { data: scans = [] } = useScansOfCurrentStore()
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  const { scanId: selectedScanId } = useParams<{ scanId?: typeof LATEST_SCAN_KEYWORD | string }>()

  let selectedScan
  if (selectedScanId === LATEST_SCAN_KEYWORD) selectedScan = scans[0]
  else selectedScan = scans.find(scan => scan.id === selectedScanId)

  if (!selectedScanId || !selectedScan) {
    throw new Error(`Invalid Scan selected: ${selectedScanId}.`)
  }

  const isLatest = selectedScanId === LATEST_SCAN_KEYWORD

  return { ...selectedScan, pathParam: selectedScanId, isLatest: isLatest }
}

export function useScanId() {
  const { id: selectedScanId } = useScan()
  return selectedScanId
}
